import React, { useState } from 'react';
import InputField from '../../input-field';
import Button from '../../button';
import { useRouter } from 'next/router';
import Link from '../../link';
import { getAdminReturnTo } from '../../../lib/admin-return-to';

const AccountSigninForm: React.FC = () => {
  const router = useRouter();

  // Account
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!username || !password) {
      setMessage('Username and password is required.');
      return;
    }

    const res = await fetch('/api/signin', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username: username, password: password }),
    });

    if (res.ok) {
      const json = await res.json();
      const query = new URLSearchParams({ token: json.jwt });
      const returnTo = getAdminReturnTo(router.query.returnTo);
      if (returnTo) query.set('returnTo', returnTo);
      await router.push(`/token?${query.toString()}`);
    } else {
      try {
        const json = await res.json();
        if (json && json.error) {
          setMessage(json.error);
        } else {
          setMessage('Incorrect log in details.');
        }
      } catch (e) {
        setMessage('Incorrect log in details.');
      }
    }
  };

  return (
    <div className="content">
      <form>
        <h2>Account</h2>
        <p>
          <strong>Notice:</strong> If you have been on this site before, please
          use your existing account information or use the{' '}
          <Link href="/account/forgot-password">
            <a>forgot password link</a>
          </Link>
          .
        </p>
        <p className="mb-1">
          If you are a Volvo Retailer, please log in through the Retailer Portal
          and click on the Volvo Car Bookstore Link.
        </p>
        <InputField
          cy="username"
          id="username"
          label="Username"
          type="text"
          onChange={(e) => setUsername(e.target.value)}
        />
        <InputField
          cy="password"
          id="password"
          label="Password"
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button cy="sign-in-button" text="Sign In" onClick={handleSubmit} />
        {message && <p>{message}</p>}
      </form>
      {/* language=CSS */}
      <style jsx>{`
        h2 {
          margin: 0 0 1rem;
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
        }

        p {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          margin: 0;
        }

        p.mb-1 {
          margin-bottom: 1rem;
        }

        a {
          color: #333;
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
        }

        a:hover {
          color: #707070;
        }
      `}</style>
    </div>
  );
};

export default AccountSigninForm;
